let LoginApiUrl;
const LoginApiUrls = {
    production: "https://api.powerofpatients.com",
    test: "https://test-api.powerofpatients.com",
};

if (window.location.hostname.startsWith("iiss")) {
    LoginApiUrl = LoginApiUrls.production;
} else {
    LoginApiUrl = LoginApiUrls.test;
}

let ApiUrl;
const ApiUrls = {
    production: "https://api.powerofpatients.com:8080",
    test: "https://test-api.powerofpatients.com:8080",
    development: "http://localhost:4242",
};

if (window.location.hostname.startsWith("localhost")) {
    ApiUrl = ApiUrls.development;
} else if (window.location.hostname.startsWith("test")) {
    ApiUrl = ApiUrls.test;
} else {
    ApiUrl = ApiUrls.production;
}

export { ApiUrl, LoginApiUrl };
